import type { SegmentedVariantProps } from '@ui-kit/components/formComponents/DateTimePicker/types'

const SEGMENT_VALUE_PATTERN = /^(\d{4})-(\d{1,2})-(\d{1,2})$/

export const parseSegmentValues = (value: string) => {
  const segments = value.match(SEGMENT_VALUE_PATTERN)
  if (!segments) {
    return { day: '', month: '', year: '' }
  }
  const [, year, month, day] = segments
  return {
    day: day.padStart(2, '0'),
    month: month.padStart(2, '0'),
    year,
  }
}

export const padIfNonEmpty = (input: string) => (input ? input.padStart(2, '0') : '')

export const composeValue = (day: string, month: string, year: string) => `${year}-${month}-${day}`

export const assertSupportedHideConfig = (props: SegmentedVariantProps) => {
  if (props.hideMonth && props.hideYear) {
    throw new Error('DateTimePicker: Dates with only the day field are not supported')
  }
  if (props.hideMonth && !props.hideYear && !props.hideDay) {
    throw new Error('DateTimePicker: Dates with day and year but with no month are not supported')
  }
  if (props.hideYear) {
    throw new Error('DateTimePicker: Dates without year are not supported')
  }
}
